// بطاقة KPI بلون كامل + ظلال 3D عميقة على الحاوية نفسها. نغمات موسّعة لتجنّب تكرار الألوان.
const TONES = {
  sky:     "bg-sky-500 text-white",
  emerald: "bg-emerald-500 text-white",
  amber:   "bg-amber-500 text-white",
  rose:    "bg-rose-500 text-white",
  violet:  "bg-violet-500 text-white",
  indigo:  "bg-indigo-500 text-white",
  teal:    "bg-teal-500 text-white",
  fuchsia: "bg-fuchsia-500 text-white",
  orange:  "bg-orange-500 text-white",
  cyan:    "bg-cyan-500 text-white",
  lime:    "bg-lime-500 text-white",
  primary: "bg-primary text-primary-foreground",
};
const NEUTRAL = "border border-border/60 bg-background text-foreground shadow-neu-sm";

// ظل ثلاثي الأبعاد: طبقة خارجية عميقة + طبقة تلامس دقيقة + برُوز داخلي علوي + انحناء داخلي سفلي.
const CARD_3D = {
  boxShadow:
    "0 14px 28px rgba(0,0,0,0.32), 0 8px 12px rgba(0,0,0,0.20),"
    + " inset 0 1.5px 0 rgba(255,255,255,0.28), inset 0 -4px 10px rgba(0,0,0,0.18)",
};
const VALUE_3D = {
  textShadow:
    "0 1px 0 rgba(0,0,0,0.20), 0 2px 0 rgba(0,0,0,0.16), 0 3px 0 rgba(0,0,0,0.12), 0 6px 12px rgba(0,0,0,0.40)",
};
const ICON_3D = "drop-shadow-[0_4px_6px_rgba(0,0,0,0.40)]";

export const StatCard = ({ label, value, hint, icon: Icon, testId,
                          accent = false, tone, onClick, active = false, compact = false }) => {
  const key = tone || (accent ? "primary" : null);
  const colored = !!key;
  const surface = colored ? TONES[key] : NEUTRAL;
  const shape = compact ? "rounded-xl p-2.5 sm:rounded-3xl sm:p-5" : "rounded-3xl p-5";
  const base = `animate-rise-in ${shape} transition-[box-shadow,transform] duration-300 ${surface}`;
  const style = colored ? CARD_3D : undefined;
  const labelCls = colored
    ? `${compact ? "text-[11px] sm:text-xs" : "text-xs"} font-bold uppercase tracking-wide text-white/85`
    : "label-xs";
  const iconCls  = colored
    ? `${compact ? "h-5 w-5 sm:h-6 sm:w-6" : "h-6 w-6"} text-white ${ICON_3D}`
    : "h-5 w-5 text-muted-foreground";
  const valueCls = `font-mono font-bold ${colored ? "text-white" : "text-foreground"} ${
    compact ? "mt-1 text-2xl sm:mt-3 sm:text-3xl" : "mt-3 text-3xl"
  }`;
  const hintCls  = colored ? "mt-1 text-xs text-white/80" : "mt-1 text-xs text-muted-foreground";
  const inner = (
    <>
      <div className="flex items-start justify-between gap-3">
        <p className={labelCls}>{label}</p>
        {Icon ? <Icon className={iconCls} /> : null}
      </div>
      <p className={valueCls} style={colored ? VALUE_3D : undefined}>{value}</p>
      {hint ? <p className={hintCls}>{hint}</p> : null}
    </>
  );
  if (!onClick) return <div className={base} style={style} data-testid={testId}>{inner}</div>;
  return (
    <button type="button" onClick={onClick} data-testid={testId} style={style}
            className={`${base} text-start hover:-translate-y-1 ${active ? "shadow-neu-in" : ""}`}>
      {inner}
    </button>
  );
};
